var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-icone"},[_c('i',{staticClass:"container_icon",class:[_vm.classe],style:({'font-size': _vm.size, 'color': _vm.cor})})])}
var staticRenderFns = []

export { render, staticRenderFns }